var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    {
      staticClass: "sticky-questionnaire",
      class: {
        expanded: _vm.isExpanded,
        submitted: _vm.isSubmitted,
        "sticky-questionnaire--closed": !_vm.isExpanded,
        "cookie-consent-rejected": !_vm.cookiesAccepted
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "sticky-questionnaire__tab",
          on: {
            click: function($event) {
              return _vm.toggleExpand()
            }
          }
        },
        [
          !_vm.isSubmitted
            ? _c("span", { staticClass: "sticky-questionnaire__tab-text" }, [
                _vm._v(
                  "Fühlst du dich jetzt besser vorbereitet im nächsten Termin über deine HIV-Behandlung zu sprechen?"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isSubmitted
            ? _c("span", { staticClass: "sticky-questionnaire__tab-text" }, [
                _vm._v("Danke für deine Bewertung!")
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("section", { staticClass: "sticky-questionnaire__content" }, [
        _c(
          "button",
          {
            staticClass: "sticky-questionnaire__close",
            on: {
              click: function($event) {
                return _vm.toggleExpand()
              }
            }
          },
          [_vm._v("×")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "sticky-questionnaire__content-wrapper",
            on: {
              click: function($event) {
                !_vm.cookiesAccepted && _vm.openCookieSettings()
              }
            }
          },
          [
            !_vm.isSubmitted
              ? _c("div", { staticClass: "sticky-questionnaire__form" }, [
                  _c("h3", { staticClass: "sticky-questionnaire__question" }, [
                    _vm._v(
                      "Fühlst du dich jetzt besser vorbereitet im nächsten Termin über deine HIV-Behandlung zu sprechen?"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sticky-questionnaire__options" }, [
                    _c(
                      "label",
                      { staticClass: "sticky-questionnaire__option" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedOption,
                              expression: "selectedOption"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "empowerment",
                            value: "Gering",
                            disabled: !_vm.cookiesAccepted
                          },
                          domProps: {
                            checked: _vm._q(_vm.selectedOption, "Gering")
                          },
                          on: {
                            change: [
                              function($event) {
                                _vm.selectedOption = "Gering"
                              },
                              function($event) {
                                return _vm.handleOptionChange("Gering")
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkbox-custom" }),
                        _vm._v("\n            Gering\n          ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "sticky-questionnaire__option" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedOption,
                              expression: "selectedOption"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "empowerment",
                            value: "Mittel",
                            disabled: !_vm.cookiesAccepted
                          },
                          domProps: {
                            checked: _vm._q(_vm.selectedOption, "Mittel")
                          },
                          on: {
                            change: [
                              function($event) {
                                _vm.selectedOption = "Mittel"
                              },
                              function($event) {
                                return _vm.handleOptionChange("Mittel")
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkbox-custom" }),
                        _vm._v("\n            Mittel\n          ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "sticky-questionnaire__option" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedOption,
                              expression: "selectedOption"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "empowerment",
                            value: "Sehr",
                            disabled: !_vm.cookiesAccepted
                          },
                          domProps: {
                            checked: _vm._q(_vm.selectedOption, "Sehr")
                          },
                          on: {
                            change: [
                              function($event) {
                                _vm.selectedOption = "Sehr"
                              },
                              function($event) {
                                return _vm.handleOptionChange("Sehr")
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkbox-custom" }),
                        _vm._v("\n            Sehr\n          ")
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "sticky-questionnaire__submit",
                      attrs: {
                        disabled: !_vm.selectedOption && _vm.cookiesAccepted
                      },
                      on: {
                        click: function($event) {
                          _vm.cookiesAccepted
                            ? _vm.submitFeedback()
                            : _vm.openCookieSettings()
                        }
                      }
                    },
                    [_vm._v("\n          Absenden\n        ")]
                  )
                ])
              : _c("div", { staticClass: "sticky-questionnaire__thank-you" }, [
                  _c("p", [_vm._v("Danke für Deine Bewertung!")])
                ]),
            _vm._v(" "),
            !_vm.cookiesAccepted
              ? _c(
                  "div",
                  {
                    staticClass: "cookie-consent-overlay",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.openCookieSettings.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "\n          Hinweis: Um an der Umfrage teilnehmen zu können, akzeptiere bitte hier die funktionellen Cookies:\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.openCookieSettings.apply(null, arguments)
                          }
                        }
                      },
                      [_vm._v("Cookie-Einstellungen verwalten.")]
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-194ff979", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-194ff979","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/content/StickyQuestionnaire.vue
// module id = 580
// module chunks = 0